export enum ProgramNameEnum {
    D_Pen = 'd-pen',
    Neo_Pen = 'neo-pen',
  }